import PrimaryLinks from './PrimaryLinks';

export default PrimaryLinks;
